import {
  Logger,
  type UserProfileData,
  type UserUpdateInput,
  type UserUpdateSuccess,
  type UserUpdateUser,
} from '@terros/common'
import { useVideoCache } from '../video/cache'
import { useTeamCache } from '../team/cache'
import { useTaskCache } from '../task/cache'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useProfile } from './get'
import { useUserCache } from './cache'

const logger = new Logger('useUpdateUser')

//logger.level = 'verbose'

export function useUpdateUser(): UpdateHookResponse<UserUpdateUser, UserProfileData> {
  logger.verbose('calling useUpdateUser')
  const mutation = useTantalimMutation<UserUpdateInput, UserUpdateSuccess>({ url: '/user/update' })
  const cache = useUserCache()
  const taskCache = useTaskCache()
  const teamCache = useTeamCache()
  const profile = useProfile()
  const videoCache = useVideoCache()

  async function update(user: UserUpdateUser): Promise<UserProfileData> {
    const response = await mutation.mutateAsync({ user })
    logger.verbose('saved user', response.user)
    updateCache(response.user)
    return response.user
  }

  function updateCache(user: UserProfileData): void {
    const { userId } = user
    cache.clearItem(userId)
    cache.clearProfile(userId)
    cache.clearList()
    cache.clearList(user.companyId)
    taskCache.clearList()
    teamCache.replaceUser(user)
    videoCache.replaceProfileItem(user)
    if (profile.user?.userId === user.userId) {
      cache.clearProfile()
    }
  }

  return mutationUpdate(mutation, update)
}
